import { Alert } from '@designsforhealth/dfh-react-components'
import { Subscribe } from '@react-rxjs/core'
import React, { useEffect } from 'react'

import { useResultWithLeftEffect } from '../../../../hooks/useResultWithLeftEffect'
import {
  latestCurrentDispensaryWithPatientFallback$,
  setCurrentDispensaryWithPatientFallbackInput,
  useCurrentDispensaryWithPatientFallback,
} from '../../../../lib/dispensaries/current-with-patient-fallback'
import { useDispensaryContext } from '../../../../lib/dispensaries/hooks/useDispensaryContext'
import { constNull } from '../../../../utils/constant'
import { pluckData } from '../../../../utils/result'
import Spinner from '../../../Spinner'
import { RequestTestKitCallToAction } from '../DispensaryTestKitRequestCallToAction'
import * as Styled from './styled'

interface DispensaryTestKitRequestProps {
  productSku: string
}

const DispensaryTestKitRequestContent: React.FC<DispensaryTestKitRequestProps> = ({
  productSku,
}) => {
  const [status, dispensaryResult] = useCurrentDispensaryWithPatientFallback()
  const [, dispensary] = useResultWithLeftEffect(dispensaryResult, pluckData, constNull)

  if (status === 'rootSiteAnonymous' || status === 'currentDispensaryAnonymous') {
    // if anonymous, prompt login and redirect back to the current page
    return <Styled.LoginButtonLink>Log in to Request a Test</Styled.LoginButtonLink>
  }
  if (!dispensary) {
    // ideally all users have active dispensary and this alert won't show
    return (
      <Alert type="informational" hideAlertIcon>
        Go to a Virtual Dispensary in order to request Spotlight Tests
      </Alert>
    )
  }
  // if in a dispensary or in root site but patient has active dispensary
  return <RequestTestKitCallToAction dispensary={dispensary} productSku={productSku} />
}

export const DispensaryTestKitRequest: React.FC<DispensaryTestKitRequestProps> = ({
  productSku,
}) => {
  const dispensaryContext = useDispensaryContext()

  useEffect(() => {
    setCurrentDispensaryWithPatientFallbackInput({ dispensaryContext })
  }, [dispensaryContext])

  return (
    <Subscribe source$={latestCurrentDispensaryWithPatientFallback$} fallback={<Spinner loading />}>
      <DispensaryTestKitRequestContent productSku={productSku} />
    </Subscribe>
  )
}
